import { QuestionProps } from '@mission.io/question-views'
import React from 'react'
import { FaTrash } from 'react-icons/fa'
// import { FaTrash, FaClone } from 'react-icons/fa'

import { UPDATE_QUESTION_ACTIONS } from '../model/editableQuestion/actions'

/**
 * The footer for a question when a teacher is editing/creating said question.
 * @param {{onChange: cb}} props
 * @returns {JSX.Element}
 */
export default function EditFooter({
	onChange,
}: {
	onChange: QuestionProps.ForTeacher['onChange']
}): JSX.Element {
	const handleDeleteQuestion = () => {
		if (!onChange) return
		onChange({
			type: UPDATE_QUESTION_ACTIONS.DELETE_QUESTION,
		})
	}
	// const handleDuplicateQuestion = () => {
	// 	if (!onChange) return
	// 	onChange({ type: UPDATE_QUESTION_ACTIONS.DUPLICATE_QUESTION })
	// }
	return (
		<div className="flex p-2 bg-brand-deep-blue text-brand-cloud-blue rounded-b-lg">
			<button
				onClick={handleDeleteQuestion}
				className="flex items-center hover:brightness-90 active:brightness-75 px-2 space-x-1">
				<FaTrash size={12} />
				<span>Delete</span>
			</button>
			{/*
				TODO: Fix Duplicate Bugs: Image labeling image uploads are messed up and image labeling selecting icons/tabs don't work as expected 
				<button onClick={handleDuplicateQuestion}>
					<FaClone size={12} />
					<span css="margin-left: 4px;">Duplicate</span>
				</button> */}
		</div>
	)
}
